document.addEventListener("DOMContentLoaded", function () {
    //collection images slider
    const collectionImageSliderId = `.grid-slick-slider`;
    collectionImagesSlider(collectionImageSliderId);
    initDeferredImageCards();

    //Quick add button
    document.querySelectorAll('.ezr_size_swatches').forEach(function(wrapper) {
        const swatches = wrapper.querySelectorAll('.ezr_add_to_cart_swatch');

        const getSelectedVariant = () => {
        const active = wrapper.querySelector('.ezr_add_to_cart_swatch.active');
        return active ? active.dataset.id : null;
        };

        wrapper.addEventListener('click', function(event) {
            event.preventDefault();
            const clicked = event.target.closest('.ezr_add_to_cart_swatch');

            if (clicked && wrapper.contains(clicked)) {
                const swatches = wrapper.querySelectorAll('.ezr_add_to_cart_swatch');
                
                swatches.forEach(s => s.classList.remove('active'));
                clicked.classList.add('active');
            }
        });

        const addButton = wrapper.querySelector('.ezr_add_button');
        if (addButton) {
        addButton.addEventListener('click', function () {
            
            const variantId = getSelectedVariant();
            if (!variantId) return;

            addButton.disabled = true;
            //addButton.classList.add('ezr--loading');

            fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
            })
            .then(res => res.json())
            .then(data => {
            //console.log('Added to cart:', data);
            $('body').trigger('added.ajaxProduct');

            })
            .catch(err => {
            console.error('Add to cart error:', err);
            })
            .finally(() => {
            addButton.disabled = false;
            //addButton.classList.remove('ezr--loading');
            });
        });
        }
    });
});

function collectionImagesSlider(elem){
  var $slider = $(elem);

  if ($slider.hasClass('slick-initialized')) return;

  $slider.slick({
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,    
    lazyLoad: 'progressive',
    prevArrow: `<img class="sslick-prev-arrow" src="${$slider.attr('data-prev-arrow')}" alt="Previous">`,
    nextArrow: `<img class="sslick-next-arrow" src="${$slider.attr('data-next-arrow')}" alt="Next">`
  });

}

function initDeferredImageCards(scope = document) {
    scope.querySelectorAll('.template-collection .grid-product, .template-search .grid-product').forEach(function(card){
        if(card.dataset.deferredInit) return;
        card.dataset.deferredInit = "true";
        let mediaLoaded = false;
        const loadOnInteraction = () => {
            if(mediaLoaded) return;
            mediaLoaded = true;
            loadDeferredMedia(card);
        };

        card.addEventListener('mouseenter', loadOnInteraction, { once: true });
        card.addEventListener('touchstart', loadOnInteraction, { once: true });
        card.addEventListener('click', loadOnInteraction, { once: true });

        const slider = card.querySelector('.grid-slick-slider');
        if(slider){
            $(slider).one('swipe', loadOnInteraction);
        }
    });
}

function loadDeferredMedia(container) {
    // Load deferred images
    container.querySelectorAll('img.deferred-media[data-src]').forEach(function(img){
        img.src = img.dataset.src;
        if(img.dataset.srcset){
            img.srcset = img.dataset.srcset;
        }
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.classList.remove('deferred-media');

    });
    // Load deferred videos
    container.querySelectorAll('.deferred-video').forEach(function(video){
        video.outerHTML = video.dataset.video;
    });

}